import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'business-operations-search-results',
    templateUrl: 'business-operations-search-results.component.html',
    styleUrls: ['business-operations-search-results.component.scss']
})
export class BusinessOperationsSearchResultsComponent {
    @Input() results = [];
    @Input() searchValue = '';
    @Output() onHandleOpen = new EventEmitter();

    constructor() {
    }

    handleResultCheckbox(result) {
        result.checked = !result.checked;
    }

    handleTableRowClick(result) {
        result.collapsed = !result.collapsed;
    }

    handleOpen(result) {
        const item: any = {
            business_question: result.business_question,
            industry_segment: result.industry_segment,
            chart_names: result.chart_names,
            id: result.id,
        };
        this.onHandleOpen.emit(item);
    }

    formatCatalogState(catalogState) {
        return catalogState.split('_').map((item) => {
            return item[0].toUpperCase().concat(item.slice(1));
        }).join(' ');
    }

    copyMessage(val: string) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }
}



// WEBPACK FOOTER //
// ./src/app/business-operations/business-operations-search-results.component.ts